import { render, staticRenderFns } from "./habilitacao-juridica.vue?vue&type=template&id=35537869"
import script from "./habilitacao-juridica.vue?vue&type=script&lang=js"
export * from "./habilitacao-juridica.vue?vue&type=script&lang=js"
import style0 from "./habilitacao-juridica.vue?vue&type=style&index=0&id=35537869&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports